import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { TradeStudyCharts } from '../../models/trade-study-charts.model';

@Injectable({ providedIn: 'root' })
export class TradeStudyChartsService {
  private http = inject(HttpClient);

  async getTradeStudyCharts(quoteId: string): Promise<TradeStudyCharts> {
    const raw = await firstValueFrom(
      this.http.get<unknown>(
        `/quotes-api/quotes/${quoteId}/trade-study/charts/`,
      ),
    );

    return TradeStudyCharts.parse(raw);
  }
}
